export default "__VITE_ASSET__B8wp93hZ__"